'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'socks';
var width = 512;
var height = 512;
var aliases = [129510];
var unicode = 'f696';
var svgPathData = 'M240 0l-112 0 0 272-89.6 67.2c-24.2 18.1-38.4 46.6-38.4 76.8 0 53 43 96 96 96 15.4 0 30.5-3.7 44-10.7-6.3-8.6-11.7-17.9-16-27.8-8.7 4.2-18.2 6.4-28 6.4-35.3 0-64-28.7-64-64 0-20.1 9.5-39.1 25.6-51.2l89.6-67.2 12.8-9.6 0-160 80 0 0-32-80 0 0-64 80 0 0-32zm80 128l128 0 0 224-153.6 115.2c-11.1 8.3-24.6 12.8-38.4 12.8-35.3 0-64-28.7-64-64 0-20.1 9.5-39.1 25.6-51.2l89.6-67.2 12.8-9.6 0-160zM256 512c20.8 0 41-6.7 57.6-19.2L480 368 480 0 288 0 288 272 198.4 339.2c-24.2 18.1-38.4 46.6-38.4 76.8 0 53 43 96 96 96zM320 96l0-64 128 0 0 64-128 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSocks = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;